import React, { useState, useEffect } from 'react';
import { BinanaceNFTTickets } from '../../components/BinanaceNFTTickets';
import { BinancenftMysteryBox } from '../../components/BinancenftMysteryBox';
import styles from './BinanceNFT.module.scss';

import BinanceNFTLogo from '../../assets/imgs/binanceNFT/title-binance-nft-mobile.png';
import TowerTokenLogo from '../../assets/imgs/logo-tower.png';

import introMb from '../../assets/imgs/binanceNFT/frame-m.png'

const _second = 1000;
const _minute = _second * 60;
const _hour = _minute * 60;
const _day = _hour * 24;

const BinanceNFT = () => {
    const [countdownTime, setCountdownTime] = useState({});
    const dateNow = new Date();

    const startTimer = (_endDate) => {
        const interval = setInterval(() => {
            const timeNow = new Date();
            var result = new Date(_endDate - timeNow);

            var d = Math.floor(result / _day);
            var h = Math.floor((result % _day) / _hour);
            var m = Math.floor((result % _hour) / _minute);
            var s = Math.floor((result % _minute) / _second);

            setCountdownTime({ days: d, hours: h, minutes: m, seconds: s });
        }, 1000);

        return () => clearInterval(interval);
    };

    useEffect(() => {
        var endDate = new Date("Nov 5 2021 11:00:00 UTC");

        if (dateNow < endDate) {
            startTimer(endDate);
        }
    }, []);

    const renderCountdownBar = (
        <div className={styles.countdown_bar}>
            <div className={styles.countdown_text}>Premium Event starts in:</div>
            <div className={styles.countdown_time}>
                <div className={styles.time_instance}>
                    <div className={styles.time_number}>{countdownTime.days || 0}</div>
                    <div className={styles.time_text}>Days</div>
                </div>
                <div className={styles.time_instance}>
                    <div className={styles.time_number}>{countdownTime.hours || 0}</div>
                    <div className={styles.time_text}>Hours</div>
                </div>
                <div className={styles.time_instance}>
                    <div className={styles.time_number}>{countdownTime.minutes || 0}</div>
                    <div className={styles.time_text}>Minutes</div>
                </div>
                <div className={styles.time_instance}>
                    <div className={styles.time_number}>{countdownTime.seconds || 0}</div>
                    <div className={styles.time_text}>Seconds</div>
                </div>
            </div>
        </div>
    );

    return (
        <div className={styles.binance_nft_page}>
            {renderCountdownBar}
            <div className={styles.main_page_section}>
                <div className={styles.tower_token_logo}>
                    <a href='/'><img src={TowerTokenLogo} alt="tower-token" /></a>
                </div>
                <div className={styles.banner}>
                    <div className={styles.banner_logos}>
                        <img src={BinanceNFTLogo} alt="binance-nft" />
                        <span className={styles.banner_time}>Starts 5 Nov 11:00 AM UTC</span>
                    </div>
                </div>
            </div>
            <div className={styles.introduction_section}>
                <div className={styles.description_texts}>
                    <span className={styles.description_text_header}>Introducing TOWER Token</span>
                    <p>TOWER is an ERC-20 fungible utility token for the Animoca Brands Tower Defense game franchise: Crazy Kings, Crazy Defense Heroes, and an upcoming blockchain game.</p>
                    <p>In the first ever TOWER NFTs Sale with Binance NFT, you will be able to get TOWER Tickets that can redeem Game Card NFTs for the upcoming blockchain game and items from Crazy Defense Heroes Mobile Game, also the TOWER Mystery Box that contain a series of avatar skin NFTs.</p>
                    <p>This exciting project combines Free-to-Play with Play-to-Earn. It allows you to earn TOWER tokens simply by playing the F2P games Crazy Kings and Crazy Defense Heroes, it is also an initiative by Animoca Brands that aims to maintain balance and equitability in traditional Free-to-Play games while introducing several benefits of blockchain such as NFTs, DeFi, and governance.</p>
                </div>
                <div className={styles.intro_image_mobile}>
                    <img src={introMb} alt="" />
                </div>
            </div>
            <BinanaceNFTTickets />
            <BinancenftMysteryBox />
        </div>
    );
}

export { BinanceNFT };
